import { render } from "./payment-details.vue?vue&type=template&id=efd00aec&scoped=true&ts=true"
import script from "./payment-details.vue?vue&type=script&lang=ts"
export * from "./payment-details.vue?vue&type=script&lang=ts"

import "./payment-details.vue?vue&type=style&index=0&id=efd00aec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd00aec"]])

export default __exports__